import * as types from './mutation-types';
import collect from 'collect.js';

export default {
    namespaced: true,
    strict: true,
    state: {
        sections: []
    },
    mutations: {
        [types.SECTIONS](state, sections) {
            state.sections = sections;
        }
    },
    actions: {
        setSections({ commit }, sections) {
            commit(types.SECTIONS, sections);
        },

        getInfoPanel({ state }, name) {
            return new Promise((resolve, reject) => {
                const sections = collect(state.sections);
                let panel = sections
                    .pluck('children')
                    .collapse()
                    .firstWhere('route', name);

                if (panel && panel.info_panel) {
                    resolve({
                        type: 'section',
                        title: `${panel.name} Application Facts`,
                        panel: panel.info_panel
                    });
                } else {
                    reject();
                }
            });
        }
    },
    getters: {}
};
